import { LegendItem } from "@Components/forecast/label/LegendLabel";
import { OneHourInterval, ThreeHourInterval } from "@Models/Interval";
import HeartIcon from "@Resources/images/iconsets/heart.svg?react";
import SunIcon from "@Resources/images/iconsets/sun.svg?react";

export const getTemperatureLegend = (
  interval: OneHourInterval | ThreeHourInterval,
) => {
  const hasFeltTemperature = typeof interval?.TTTFEEL_C === "number";

  return hasFeltTemperature
    ? TEMPERATURE_LEGEND
    : TEMPERATURE_LEGEND.filter(
        (item) => item.translationKey !== "feltTemperature",
      );
};

export const TEMPERATURE_LEGEND: LegendItem[] = [
  { translationKey: "rainAmount" },
  {
    translationKey: "sunshineDuration",
    icon: <SunIcon height="16" width="16" preserveAspectRatio="none" />,
  },
  { translationKey: "rainProbability" },
  {
    translationKey: "feltTemperature",
    icon: <HeartIcon height="16" width="16" preserveAspectRatio="none" />,
  },
];

export const WIND_LEGEND: LegendItem[] = [{ translationKey: "windSpeed" }];

export const SNOW_LEGEND: LegendItem[] = [{ translationKey: "freshSnow" }];
